import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const PDPMobileConfigurationPhotoGallery3dViewer = ({ hidden, children }) => (
  <div
    className={classNames(
      'h-[100vw] lg:min-h-[750px] [&_.mxt-btn-download]:hidden [&_.mxt-btn-expand]:hidden [&_.mxt-ar-button-short]:hidden',
      {
        hidden,
      }
    )}
  >
    {children}
  </div>
);

PDPMobileConfigurationPhotoGallery3dViewer.propTypes = {
  hidden: PropTypes.bool,
  children: PropTypes.node,
};

export default PDPMobileConfigurationPhotoGallery3dViewer;
